module.exports = {
  getWebSocketBase: function () {
    var base = (window.location.protocol === 'http:' ? 'ws://' : 'wss://')
    var host = (window.location.hostname === 'localhost' ? '192.168.0.208/deepstream' : window.location.host)
    return base + host
  },
  getHTTPBase: function () {
    var base = (window.location.protocol === 'http:' ? 'http://' : 'https://')
    var host = (window.location.hostname === 'localhost' ? '192.168.0.208/' : window.location.host + '/')
    return base + host
  }
}



// WEBPACK FOOTER //
// ./src/helpers/host.js